import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import BrazilFlagIcon from "./icons/brazil-flag-icon";
import SpainFlagIcon from "./icons/spain-flag-icon";
import UnitedStatesFlagIcon from "./icons/united-states-flag-icon";
import { Language, LanguagesList, SelectLanguageButton } from "./index.styled";
import { changeUserLanguage } from "../../store/application/application-actions";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store/app-state";

interface LanguageSelectionProps {
  showAllLanguages?: boolean;
}

const locales = ["pt-BR", "en", "es"];

const iconMap = new Map<string, JSX.Element>();
iconMap.set("pt-BR", <BrazilFlagIcon />);
iconMap.set("en", <UnitedStatesFlagIcon />);
iconMap.set("es", <SpainFlagIcon />);

const LanguageSelection: React.FC<LanguageSelectionProps> = ({
  showAllLanguages = true,
  ...props
}) => {
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const user = useSelector((state: AppState) => state.authState.user);

  const handleLocaleChange = useCallback(
    (locale: string) => {
      i18n.changeLanguage(locale);
      if (user?.id)
        dispatch(changeUserLanguage(locale, user.id));
    },
    [i18n, user, dispatch]
  );


  return (
    <LanguagesList {...props}>
      {locales.map((locale) => (
        <Language key={locale}>
          <SelectLanguageButton
            type="button"
            onClick={() => handleLocaleChange(locale)}
            title={t(`languages.${locale}`)}
            active={i18n.language === locale}
          >
            {iconMap.get(locale)}
            {t(`languages.${locale}`)}
          </SelectLanguageButton>
        </Language>
      ))}
    </LanguagesList>
  );
};

export default LanguageSelection;
